import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { PATHS } from '../../../../../Config/Routing/paths'
import ArrowBackIcon from '../../../../ClientSettings/icons/ArrowBackIcon'
import { getNextLink } from '../../../../../Utils/Link'
import injectStyles from 'react-jss'
import Button from '@material-ui/core/Button'
import AddIcon from '@material-ui/icons/Add'
import StyledModal from '../../../../../Components/Modal/StyledModal'
import LoadingIndicator from '../../../../../Components/LoadingIndicator/LoadingIndicator'
import IntegrationsService from '../../../../../Module/IntegrationsService/client'
import classNames from 'classnames'
import SwellIcon from '../../../../ClientSettings/icons/SwellIcon'
import { authorization } from '../../../../../Module/Auth/Auth'
import { styles } from './styles'
import SwellActionMenu from './components/SwellActionMenu'
import usePosthogAnalyticsIntegrations from '../../../hooks/usePosthogAnalyiticsIntegrations'

const SwellStores = ({ classes }) => {
  const history = useHistory()
  const [isLoading, setIsLoading] = useState(true)
  const [stores, setStores] = useState([])
  const { client } = authorization.getUser()

  const [disconnectedItem, setDisconnectedItem] = useState(false)

  const { emitAnalyticsEvent } = usePosthogAnalyticsIntegrations()

  const getCards = async () => {
    const integrations = await IntegrationsService.readIntegrations()
    return integrations.reduce((acc, integration, index) => {
      if (integration.status == 10) {
        acc.push({
          id: integration.id,
          title: `${integration.credentials.storeId}`, // INTEGRATIONS_TODO: add proper name field
          description: index + 1,
          date: new Date(integration.createdAt).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          }),
          actions: [
            {
              id: 1,
              name: 'Disable connection',
              onClick: async () => {
                emitAnalyticsEvent('Store Action', {
                  action_type: 'disable',
                  type: 'swell',
                  storeId: integration.credentials.storeId,
                })
                await IntegrationsService.updateIntegration({
                  integrationId: integration.id,
                  status: 0, // INACTIVE
                })
                await fetchCards()
              },
              style: {
                color: '#004360',
              },
            },
          ],
        })
      }

      return acc
    }, [])
  }

  const fetchCards = async () => {
    setIsLoading(true)
    const cards = await getCards()
    setStores(cards)
    setIsLoading(false)
  }

  useEffect(() => {
    // added here as coming from next the trigger is lost
    emitAnalyticsEvent('Clicked Manage Integration', {
      type: 'swell',
    })
    fetchCards()
  }, [])

  const onBack = () => {
    window.location.href = getNextLink(
      `${PATHS.main.dashboard}${client ? `/${client.id}` : ''}${
        PATHS.dashboard.integrations
      }`,
    )
  }

  const onAddStore = () => {
    emitAnalyticsEvent('Store Action', {
      action_type: 'add_new',
      type: 'swell',
    })
    history.push(
      `${PATHS.main.dashboard}${PATHS.dashboard.integrations}${
        PATHS.integrations.swellStores
      }${PATHS.integrations.addSwellStore}`,
    )
  }

  const onDisconnect = async () => {
    setIsLoading(true)
    setDisconnectedItem(false)

    await new Promise(() => {
      setTimeout(() => {
        setIsLoading(false)
      }, 1500)
    })
  }

  return (
    <div className={classes.container}>
      {disconnectedItem ? (
        <StyledModal
          isOpen={disconnectedItem}
          title={`Disable connection Store ${disconnectedItem}`}
          text={`Are you certain you want to disconnect the store ${disconnectedItem}`}
          onClose={() => setDisconnectedItem(false)}
          onConfirm={onDisconnect}
          confirmLabel="Yes"
        />
      ) : null}
      <div className={classes.titleWrap}>
        <div className={classes.title}>
          <div className={classes.back} onClick={onBack}>
            <ArrowBackIcon height={12} width={16} color="#4F5B94" />
            Back to Integrations
          </div>
          <div className={classes.titleIconButton}>
            <div className={classes.titleIcon}>
              <SwellIcon width={130} height={56} />
            </div>
            <Button
              variant="outlined"
              startIcon={<AddIcon />}
              onClick={onAddStore}
              className={classes.button}
              cypress_id="addStoreBtn"
            >
              Add Store
            </Button>
          </div>
        </div>
      </div>
      <div className={classes.description}>
        Add or select the store you would like to create coupons for.
      </div>
      {isLoading ? (
        <LoadingIndicator style={{ height: '42vh' }} />
      ) : (
        <div className={classNames(classes.cardWrapper, 'cardWrapper')}>
          {stores.map(card => (
            <div className={classes.card} key={card.id} cypress_id="storeCard">
              <div className={classes.cardTitle}>
                <div cypress_id={'storeCardTitle'}>{card.title}</div>
                {card.actions ? (
                  <div className={classes.actionWrapper}>
                    <SwellActionMenu options={card.actions} />
                  </div>
                ) : null}
              </div>
              <div className={classes.cardDescription} cypress_id={'storeId'}>
                Store ID #{card.description}
              </div>
              <div className={classes.date} cypress_id={'storeDate'}>
                Added: {card.date}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default injectStyles(styles)(SwellStores)
